import React from "react";

const Files = () => {
  return <div> Files Page Files Page Files Page</div>;
};

export default Files;
